(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-cart"]) return;
  try {
    
  (function () {
    var checkbox = document.querySelector('[data-cart-terms-checkbox]');

    // The wallet buttons (Google Pay / Apple Pay) checkout this cart by id without
    // submitting the form, so the attribute has to live on the cart itself. Write it
    // as soon as the box is ticked, before the buyer can reach a wallet button.
    var ATTRIBUTE = 'A accepté les CGV';
    // Unticking clears the attribute (Shopify drops empty values) rather than storing
    // "No", so an order only ever carries the acceptance or nothing at all.
    var persist = function (checked) {
      var attributes = {};
      attributes[ATTRIBUTE] = checked ? 'Yes' : '';
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
      }).catch(function () {
        // Non-fatal: the form submit still carries the attribute on the normal path.
      });
    };

    // An emptied cart keeps no acceptance; the checkbox is not rendered in that state.
    if (!checkbox) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count === 0 && cart.attributes && cart.attributes[ATTRIBUTE]) persist(false);
        })
        .catch(function () {});
      return;
    }

    var form = checkbox.closest('form');
    var button = document.querySelector('[data-cart-terms-gated-button]');
    var wallets = document.querySelector('[data-cart-terms-wallets]');
    var error = document.querySelector('[data-cart-terms-error]');

    var syncGated = function (checked) {
      if (button) button.disabled = !checked;
      if (wallets) wallets.classList.toggle('cart-terms-gated', !checked);
      if (error && checked) error.hidden = true;
    };

    checkbox.addEventListener('change', function () {
      syncGated(checkbox.checked);
      // Keep the wallets gated until the cart actually holds the acceptance, so a tick
      // followed by an instant wallet click cannot race the request.
      if (checkbox.checked) {
        if (wallets) wallets.classList.add('cart-terms-gated');
        persist(true).then(function () {
          if (checkbox.checked && wallets) wallets.classList.remove('cart-terms-gated');
        });
      } else {
        persist(false);
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!checkbox.checked) {
          event.preventDefault();
          if (error) error.hidden = false;
          checkbox.focus();
        }
      });
    }

    // Restore from the cart so a reload does not show an unticked box for a cart that
    // has already accepted (and so the two never disagree).
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var accepted = cart.attributes && cart.attributes[ATTRIBUTE] === 'Yes';
        checkbox.checked = accepted;
        syncGated(accepted);
      })
      .catch(function () {
        syncGated(checkbox.checked);
      });
  })();

  } catch(e) { console.error(e); }
})();
})();
